var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
require("clover/data/ItemDataManager")
let SnsProxy = require("clover/sns/SnsProxy")
let ShareUtil = require("clover/utils/ShareUtil")
/**
 * 该面板主要用于获取银币操作
 */
var CoinNotEnoughPanel = xClass("CoinNotEnoughPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/frame_purchase2_frame_nosilver.csb")
})
let preload_res = []
let extra_plist = "cocos/frame_purchase2.plist"
/**
 * 显示面板
 * @param flag  是否背景变黑
 * @param onCloseCallback   关闭回调
 */
CoinNotEnoughPanel.show = function (flag, onCloseCallback, from = ModuleName.WX_COINSHORT_SHARE, changeOnly = false) {
    function callback() {
        var _panel = CoinNotEnoughPanel.create(onCloseCallback, from, changeOnly)
        _panel.popup(flag)
    }
    function onFail() {
        Toast.make(getText("error.tip.timeout"))
    }
    preload_res = [
		"packed/CoinNotEnoughPreloadConfig.pack"
	];
    if (!cc.loader.getRes(getRealResourceName(extra_plist))) {
        preload_res.push(extra_plist)
    }
    let preload_list = buildResList(preload_res)
    preloadWithLoading(preload_list, callback, onFail)
}
/**
 * 构造函数
 * @param changeOnly 是否只允许货币兑换
 */
CoinNotEnoughPanel.prototype.ctor = function (onCloseCallback, from = ModuleName.WX_COINSHORT_SHARE, changeOnly = false) {
    var self = this

    self.bannerAdName = BannerAdPanel.kCoinNotEnough
    self.gridAdName = GridAdPanel.kCoinNotEnough;
    self.from = from
    self.onCloseCallback = onCloseCallback
    self.changeOnly = changeOnly;
    //self.onConfirm = confirmCallback
    //self.onCancel = cancelCallback
    self.init()
    self.tryShowBannerAd();
}
/**
 * 兑换信息条目
 */
CoinNotEnoughPanel.config = {
    changeItemId : 7,
    shareLeftTime : 60000,
    useVideo : false,
    useShare : false,
    freeCoin : 5000
}
/**
 * 初始化面板
 */
CoinNotEnoughPanel.prototype.init = function () {
    var self = this

    BasePanel.prototype.init.call(self)
    
    //  标题
    self.title = self.getChildByName("title")
    self.title.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.title.setString(getText("buy.props.coinlack.title"))
    self.title.setAnchorPoint(0.5, self.title.getAnchorPoint().y)
    self.title.setPositionX(self.getContentSize().width / 2)

    //  气泡文本
    self.bubbleText = self.getChildByName("bubble_text")
    self.bubbleText.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    let bubbleStr = getText("buy.props.coinlack.bubble")
    if (SnsProxy.getInstance().isBuyBan()) {
        bubbleStr = bubbleStr.replace(getText("shortbuy.out.buyban"), getText("shortbuy.in.buyban"))
    }
    self.bubbleText.setString(bubbleStr)
    self.bubbleText.setPositionY(self.bubbleText.getPositionY() - 8)

    //  兑换按钮
    self.changeBtn = self.getChildByName("btn_blue_addcoins")
    self.changeBtn = UIButton.create(self.changeBtn)
    ButtonPushBounceAnim.create(self.changeBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.changeBtn)
    self.changeBtn.on(UIButtonEvent.Click, function() {
        self.onChangeBtnClick()
    })
    var itemData = ItemDataManager.getItemDataById(CoinNotEnoughPanel.config.changeItemId)
    self.changeBtn.getChildByName("num1").setString(itemData.price)
    var changeBtnNum = self.changeBtn.getChildByName("num2")
    changeBtnNum.setPositionX(changeBtnNum.getPositionX() - 3)
    changeBtnNum.setString(itemData.num)
    //  免费获取按钮
    self.addBtn = self.getChildByName("btn_orange_free")
    // DYAdUtil.hideVideoIcon(self.addBtn.getChildByName("video"))
    if (self.changeOnly) {
        self.addBtn.setVisible(false);
        self.changeBtn.setPositionY(self.changeBtn.y - 50)
    } else {
        self.addBtn = UIGroupButton.create(self.addBtn)
        ButtonPushBounceAnim.create(self.addBtn)
        ButtonPushBounceIdleBubbleAnim.create(self.addBtn)
        self.addBtn.on(UIButtonEvent.Click, function () {
            self.onAddBtnClick()
        })
        self.updateBtn(self.addBtn, "disable")

        // self.addBtn.setEnabled(false)
        // let numTxt = self.addBtn.getChildByName("num")
        // numTxt.setPositionX(numTxt.getPositionX() - 10)
        // self.addBtn.getChildByName("icon2").x -= 10

        var freeNum = self.addBtn.getChildByName("num")
        freeNum.setVisible(false)
        freeNum.ignoreContentAdaptWithSize(true)
        freeNum.setNextFontPositionXOffset(-2)
        DCAssist.dc4User101("stage_start","getcoins_ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
    }
    //  关闭按钮
    self.closeBtn = self.getChildByName("btn_close")
    self.closeBtn = UIButton.create(self.closeBtn)
    self.closeBtn.on(UIButtonEvent.Click, function () {
        self.onCloseBtnClick()
    })
    self.originScale = self.getScale()
    //self.setAnchorPoint(0.5, 0.5)
    //self.setPosition(cc.p(320, 640))
    
    self.lastCanShare = false;

    //  检查免费获取状态
    self.stateCheck()

    if (SnsProxy.getInstance().isBuyBan()) {
        let lb = self.changeBtn.getChildByName("label")
        lb.setString(getText("shortbuy.in.buyban"))
    }
}
/**
 * 更新看视频或分享按钮状态
 */
CoinNotEnoughPanel.prototype.updateBtn = function (btn, state) {
    if (state == "ad"){
        btn.setEnabled(true)
        btn.getChildByName("icon_ad").setVisible(true)
        btn.getChildByName("label").setVisible(true)
        btn.getChildByName("icon1").setVisible(true)
        btn.getChildByName("num").setVisible(true)
        btn.getChildByName("icon2").setVisible(false)
        btn.getChildByName("num").x = 0
        btn.getChildByName("label").setPosition(-40, 27)
        btn.getChildByName("label").setString("加")
        btn.getChildByName("label").setScale(0.84)
    }else if (state == "share"){
        btn.setEnabled(true)
        btn.getChildByName("icon_ad").setVisible(false)
        btn.getChildByName("label").setVisible(true)
        btn.getChildByName("icon1").setVisible(true)
        btn.getChildByName("num").setVisible(true)
        btn.getChildByName("icon2").setVisible(false)
        btn.getChildByName("num").x = 0
        btn.getChildByName("label").setPosition(-95, 25)
        btn.getChildByName("label").setString("分享得")
        
        btn.getChildByName("label").setScale(0.7)
    }else if (state == "disable"){
        btn.setEnabled(false)
        btn.getChildByName("icon_ad").setVisible(false)
        btn.getChildByName("label").setVisible(false)
        btn.getChildByName("icon1").setVisible(false)
        btn.getChildByName("num").setVisible(false)
        btn.getChildByName("icon2").setVisible(true)
        
    }

} 
/**
 * 检查免费获取银币的状态，由于每次获取完银币后，面板并不会关闭，因此需要在打开面板以及操作完毕（看完广告、分享完毕）之后检查一下获取状态
 */
CoinNotEnoughPanel.prototype.stateCheck = function () {
    var self = this

    if (self.isBusy || self.changeOnly) {
        return
    }
    //  获取配置
    function onSuccess(evt) {
        self.isBusy = false
        //看视频或分享
        if ((evt.data.useVideo && SnsProxy.getInstance().allowAd()) || (evt.data.useShare && SnsProxy.getInstance().allowShare())) {
            if (evt.data.useVideo && SnsProxy.getInstance().allowAd()){
                self.updateBtn(self.addBtn, "ad")
            }else{
                self.updateBtn(self.addBtn, "share")
            }
            self.addBtn.getChildByName("num").setString(CoinNotEnoughPanel.config.freeCoin)
        } else if (SnsProxy.getInstance().allowAd() || SnsProxy.getInstance().allowShare()){
            self.updateBtn(self.addBtn, "disable")
        } else {
            if (self.changeBtn)
                self.changeBtn.setPosition(self.changeBtn.x, self.addBtn.y + 30)
            self.addBtn.setVisible( false);
        }
        CoinNotEnoughPanel.config.useShare = evt.data.useShare
        CoinNotEnoughPanel.config.useVideo = evt.data.useVideo && SnsProxy.getInstance().allowAd();

        let canShare = false;
        if (!(CoinNotEnoughPanel.config.useVideo && SnsProxy.getInstance().allowAd())
            && (CoinNotEnoughPanel.config.useShare && SnsProxy.getInstance().allowShare())) {
            canShare = true;
        }
        if (self.lastCanShare != canShare) {
            self.lastCanShare = canShare;
            if (canShare)
                DCAssist.dc4ShareShow("buy_item")
        }
    }
    function onFail(evt) {
        Toast.make(quickGetErrorText(evt.retCode, getText("error.tip.timeout")), null, () => {
            self.isBusy = false
        })
    }
    function onCancel(evt) {
        Toast.make(quickGetErrorText(evt.retCode, getText("error.tip.timeout")), null, () => {
            self.isBusy = false
        })
    }
    self.isBusy = true

    //  检查状态
    var http = GetObtainCoinHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load();
}
/**
 * 兑换按钮点击回调
 */
CoinNotEnoughPanel.prototype.onChangeBtnClick = function () {
    var self = this

    if (self.isBusy) {
        return
    }
    self.isBusy = true

    var itemData = ItemDataManager.getItemDataById(CoinNotEnoughPanel.config.changeItemId)
    var payType = UserDealPayType.kUnsupport
    if (itemData.payType === ItemDataManager.PayTypeEnum.Cash) {
        payType = UserDealPayType.kCash
    } else if (itemData.payType === ItemDataManager.PayTypeEnum.Coin) {
        payType = UserDealPayType.kCoin
    }

    function onSuccessCallback(event) {
        //  输出兑换文本
        self.isBusy = false
        Toast.make("兑换成功", null, () => {})
        //  加道具，播放动画
        var flyItemOps = table()
        var pos = self.convertToWorldSpace(cc.p(self.changeBtn.getPosition()))
        var itemData = ItemDataManager.getItemDataById(CoinNotEnoughPanel.config.changeItemId)
        table.insert(flyItemOps, table(
            [1, "itemId", 2],
            [1, "num", itemData.price],
            [1, "pos", pos],
            [1, "scale", 0.5]
        ))
        //UserProp.getInstance().rewardProp(2, itemData.price, null, null, ModuleName.WX_COINSHORT_SHARE)
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15)

        DCAssist.userTrack("stage_start", "transfer_coins", {result: 1});
    }
    function onFailCallback(event) {
        if (event.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            //  风车币不足
            var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
            CashNotEnoughPanel.show(function () {
                self.onClose()
                if (self.onCloseCallback) {
                    self.onCloseCallback()
                }
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab)
                // MarketManager.getInstance().showMarketPanel(MarketPanelTabId.kCashTab)
            }, function () {
                self.isBusy = false
                if (self.from === ModuleName.STAGE_START) {
                    self.setHideState(false)
                }
            }, true, self.from)
            if (self.from === ModuleName.STAGE_START) {
               self.setHideState(true)
            }
        } else {
            //  其他错误情况
            Toast.make(quickGetErrorText(event.data, getText("兑换失败，请稍后再试")), null, () => {
                self.isBusy = false
            })
        }
        DCAssist.userTrack("stage_start", "transfer_coins", {result: 0});
    }
    function onCancelCallback(event) {
        if (event.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            //  风车币不足
            var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
            CashNotEnoughPanel.show(function () {}, function () {
                self.isBusy = false
            }, true, self.from)
        } else {
            //  其他错误情况
            Toast.make(quickGetErrorText(event.data, getText("兑换失败，请稍后再试")), null, () => {
                self.isBusy = false
            })
        }
        DCAssist.userTrack("stage_start", "transfer_coins", {result: 0});
    }

    UserDeal.getInstance().buyItem(CoinNotEnoughPanel.config.changeItemId, 1,payType, null, null, onSuccessCallback, onFailCallback, onCancelCallback, ModuleName.WX_COINSHORT_SHARE)
}
/**
 * 免费获取按钮点击回调
 */
CoinNotEnoughPanel.prototype.onAddBtnClick = function () {

    // if (__DEBUG && !isWechatGameEnv()){
    //     this.playVideoAd()
    //     return
    // }

    var self = this
    if (self.isBusy) {
        return
    }

    //  检查看广告配置以及游戏环境是否支持
    if (
        isWechatGameEnv() 
        || (META.platform == XcloverPlatform.qq && window.OPEN_DATA.qua.app == 'SQ') || META.platform == XcloverPlatform.huawei
    ){
        if (CoinNotEnoughPanel.config.useVideo) {
            this.playVideoAd()
        } else if (CoinNotEnoughPanel.config.useShare) {
            this.sendShareMessage()
        } else {
            Toast.make("今日已达奖励获取上限");
            return
        }
    } else{
        Toast.make("当前游戏环境不支持");
        return
    } 
}
/**
 * 播放视频广告
 */
CoinNotEnoughPanel.prototype.playVideoAd = function () {
    var self = this

    if (!SnsProxy.getInstance().allowAd())
        return;
        
    if (self.isBusy || !CoinNotEnoughPanel.config.useVideo) {
        return
    }
    self.isBusy = true

    DCAssist.dc4AdClick("stage_start", "ad_getcoins_click");

    var snsProxy = SnsProxy.getInstance();
    function dropoutAdWatch() {
        Toast.make(getText("error.tip.dropout_ad"));
        self.isBusy = false;

        DCAssist.dc4AdDropOut("stage_start", "ad_getcoins_dropout");
    }
    function addCoin() {  
        console.log("CoinNotEnoughPanel.playVideoAd addCoin")
        //  加道具，播放动画
        let flyItemOps = table()
        let pos = cc.p(0,0)
        if (self.addBtn){
            pos = self.convertToWorldSpace(cc.p(self.addBtn.getPosition()))
        }
        if (!pos) pos = cc.p(0,0)
        console.log("CoinNotEnoughPanel.playVideoAd addCoin pos",pos)

        table.insert(flyItemOps, table(
            [1, "itemId", 2],
            [1, "num", CoinNotEnoughPanel.config.freeCoin],
            [1, "pos", pos],
            [1, "scale", 0.5]
        ))
        console.log("CoinNotEnoughPanel.playVideoAd addCoin flyItemOps",flyItemOps)
        UserProp.getInstance().rewardProp(2, CoinNotEnoughPanel.config.freeCoin, null, null, ModuleName.WX_AD_VIDEO_WATCH, {
            category: "ad",
            sub_category: "stage_start_getcoins"
        })
        console.log("CoinNotEnoughPanel.playVideoAd addCoin rewardProp ")
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, () => {
            // self.isBusy = false;
            console.log("CoinNotEnoughPanel.playVideoAd addCoin complete")
            //  关闭面板
            self.onCloseBtnClick()
            //  完毕后先重置操作状态到不可用，再检查免费获取状态
            CoinNotEnoughPanel.config.useVideo = false
            self.stateCheck()
        }, 0.15)
    }

    function fetchAdRewards() {
        function onSuccess(evt) {
            addCoin();
        }
        function onFail() {
            self.isBusy = false;
        }

        function onCancel() {
            self.isBusy = false;
        }

        var http = AddCoinByVideoHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load();

        DCAssist.dc4AdFinish("stage_start", "ad_getcoins_finish");
    }
    
    snsProxy.showAd("CoinNotEnough")
    .then(isEnd=> {
        if (isEnd) {
            fetchAdRewards();
        } else {
            dropoutAdWatch();
        }
    },(err)=>{
        if (err && err.errMsg){
            Toast.make(err.errMsg)
        }else{
            Toast.make(getText("video.ad.error"));
        }
        self.isBusy = false;
        DCAssist.dc4AdNoMore("stage_start", "ad_getcoins_noAds");
    }).catch(err=> {
        self.isBusy = false;
        DCAssist.dc4AdNoMore("stage_start", "ad_getcoins_noAds");
        if (!SnsProxy.getInstance().allowShare()) {
            Toast.make(getText("video.ad.error"));
        } else {
            //  无法播放广告，尝试进行分享
            this.sendShareMessage()
        }
    })
}
/**
 * 触发分享功能
 */
CoinNotEnoughPanel.prototype.sendShareMessage = function () {
    var self = this

    if (self.isBusy || !CoinNotEnoughPanel.config.useShare) {
        return
    }
    self.isBusy = true;

    DCAssist.userTrack("stage_start", "share_getcoins_send");

    function onSuccess(evt) {
        //  成功获取到shareId，发送分享链接
        self.gotoShare(evt.data.shareId);
        
    }
    function onFail(evt) {
        Toast.make(quickGetErrorText(evt.retCode, getText("error.tip.timeout")), null, () => {
            self.isBusy = false
        })
    }
    let http = AddCoinGetShareIdHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}
/**
 * 发送分享信息
 */
CoinNotEnoughPanel.prototype.gotoShare = function (shareId) {
    var self = this;
    
    function onShareSuccess(){
        self.isBusy = false;

        var showReward = function(rewards){
            var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
            GetRewardsPanel.show(ContinueCheckName.kCoinNotEnoughShare, rewards, true);
        }
        ContinueCheckManager.getInstance().registCheck(ContinueCheckName.kCoinNotEnoughShare, shareId, 10, CoinNotEnoughPanel.config.shareLeftTime, showReward);

        Toast.make(getText("get.happycoin.sharesucceed"))
    }

    function onShareFail() {
        Toast.make(getText("activity.sharefailed"));
        self.isBusy = false;
    }
    ShareUtil.clickCoinNotEnough(shareId, onShareSuccess, onShareFail, onShareFail);
}
/**
 * 关闭按钮回调
 */
CoinNotEnoughPanel.prototype.onCloseBtnClick = function () {
    var self = this

    // if (self.isBusy) {
    //     return
    // }
    self.onClose()
    if (self.onCloseCallback) {
        self.onCloseCallback()
    }
}
/**
 * 弹窗
 */
// CoinNotEnoughPanel.prototype.popup = function () {
//     var self = this

//     var targetScale = self.getScale()
//     self.setScale(0)
//     var time = 7 / 30
//     PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
//     var dH = display.height-GamePlayConfig_Design_Height;
//     var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(62, 850 + dH/2 - 100));
//     var pos_O = cc.p(display.width / 2, display.height / 2)
//     var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
//     self.setScale(0.23)
//     self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
//     cc.log(self.getPosition())
//     self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
//     //  关闭Banner广告
//     self.tryShowBannerAd();
//     return self
// }

/**
 * 清理资源
 */
CoinNotEnoughPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    // cc.warn("TODO: unload res list")
    let preload_list = buildResList(preload_res)
    unloadResList(preload_list)
    // let index = preload_res.indexOf(extra_plist)
    // if (index !== -1) {
    //     preload_res.splice(index,1)
    // }
}
/**
 * 设置隐藏状态
 * @param state 是否切换到隐藏
 */
CoinNotEnoughPanel.prototype.setHideState = function (state) {
    var self = this

    var targetScale = 0
    var time = 7 / 30
    var targetPos = null
    if (state) {
        //  隐藏面板
        fromScale = self.getScale()
        targetScale = 0
        dH = display.height - GamePlayConfig_Design_Height;
        targetPos = cc.p(291.46, 665.3)
        fromPos = cc.p(62, 850 + dH/2 - 100)
    } else {
        //  显示面板
        fromScale = 0
        targetScale = self.originScale
        dH = display.height - GamePlayConfig_Design_Height;
        targetPos = cc.p(62, 850 + dH/2 - 100)
    }
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
}
module.exports = CoinNotEnoughPanel
